import { Entity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const SQUAD_PREFIX = 'devlake-squad-';

const devlakeManageContent = EntityContentBlueprint.make({
  name: 'devlake-manage',
  params: {
    path: '/manage',
    title: 'Manage',
    filter: (entity: Entity) =>
      entity.kind.toLowerCase() === 'component' &&
      entity.metadata.name.startsWith(SQUAD_PREFIX),
    loader: async () => {
      const { ManageContent } = await import('./ManageContent');
      return <ManageContent />;
    },
  },
});

export const devlakeManageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [devlakeManageContent],
});
